import {
  Block,
  Action,
  Variable,
  NumberBlock,
  StringBlock,
  BooleanBlock,
  Time,
  Sprite,
  Text,
  Screen,
  Joystick,
  DPad,
} from "./index";
import {GRAMMAR, STATE} from "../Type";

export class Property extends Block {
  get type() {
    return "Property";
  }

  get category() {
    return "Property";
  }

  getGrammarFor(parent) {
    return parent.grammar;
  }

  getDefaultChildren() {
    if (this.grammar === GRAMMAR.SUBJECT) {
      return [new Block({state: STATE.INSTANCE, parent: this})];
    } else {
      return [];
    }
  }

  static getPrototypeBlocks() {
    const prototypeBlocks = [];
    const propertyNames = Property.getPropertyNames();
    for (let i = 0; i < propertyNames.length; i++) {
      const propertyName = propertyNames[i];
      prototypeBlocks.push(
        new Property({data: propertyName, state: STATE.PROTOTYPE}),
      );
    }
    return prototypeBlocks;
  }

  static getPropertyNames() {
    return [
      // "text",
      // "x",
      // "y",
      // "width",
      // "height",
      // "size",
      // "degree",
      // "mass",
      // "moveSpeed",
      // "draggable",
      "movable",
      // "flipX",
      // "flipY",
      "velocityX",
      "velocityY",
      "velocityZ",
      // "gravityX",
      // "gravityY",
      // "bounceX",
      // "bounceY",
      // "accelerationX",
      // "accelerationY"
    ];
  }

  getAvailableChildTypesAt() {
    return [Action];
  }

  getAvailableParentTypes() {
    switch (this.data) {
      case "text":
        return [Text, Variable];
      case "x":
      case "y":
        return [Sprite, Text, Screen, Joystick, DPad, Variable];
      case "width":
      case "height":
        return [Sprite, Text, Joystick, DPad, Variable];
      case "size":
      case "degree":
      case "mass":
      case "moveSpeed":
      case "draggable":
      case "movable":
      case "flipX":
      case "flipY":
      case "velocityX":
      case "velocityY":
      case "velocityZ":
      case "gravityX":
      case "gravityY":
      case "bounceX":
      case "bounceY":
      case "accelerationX":
      case "accelerationY":
        return [Sprite, Text, Variable];
      default:
        return [];
    }
  }

  getPropertyType() {
    switch (this.data) {
      case "text":
        return [StringBlock, Time];
      case "draggable":
      case "movable":
      case "flipX":
      case "flipY":
        return [BooleanBlock];
      case "x":
      case "y":
      case "width":
      case "height":
      case "size":
      case "degree":
      case "mass":
      case "moveSpeed":
      case "velocityX":
      case "velocityY":
      case "velocityZ":
      case "gravityX":
      case "gravityY":
      case "bounceX":
      case "bounceY":
      case "accelerationX":
      case "accelerationY":
        return [NumberBlock];
      default:
        return [];
    }
  }

  toJavascript() {
    if (this.grammar === GRAMMAR.SUBJECT) {
      const child = this.children[0];
      if (child instanceof Action && child.data === "set") {
        const childCode = child.toJavascript();
        return childCode;
      } else {
        return;
      }
    } else if (this.grammar === GRAMMAR.OBJECTIVE) {
      const upperCased = this.data[0].toUpperCase() + this.data.slice(1);
      return `.get${upperCased}()`;
    }
  }
}
